import * as Yup from "yup";

export const initialValues = {
  packages: {
    Basic: {
      isActive: true,
      price: null,
      description: null,
      services: [] as number[],
    },
    Standard: {
      isActive: true,
      price: null,
      description: null,
      services: [] as number[],
    },
    Premium: {
      isActive: true,
      price: null,
      description: null,
      services: [] as number[],
    },
  },
};
const packageSchema = Yup.object().shape({
  isActive: Yup.boolean(),
  price: Yup.number().when("isActive", {
    is: true,
    then: (schema) =>
      schema
        .typeError("Please enter a valid price for the package.")
        .min(0, "Price cannot be negative")
        .required("Please enter a valid price for the package."),
    otherwise: (schema) => schema.notRequired(),
  }),
  description: Yup.string()
    .nullable()
    .when("isActive", {
      is: true,
      then: (schema) => schema.required("Description is required"),
      otherwise: (schema) => schema.notRequired(),
    }),
  services: Yup.array()
    .of(Yup.number())
    .when("isActive", {
      is: true,
      then: (schema) =>
        schema
          .required("Please select at least one service to create a package.")
          .min(1, "Please select at least one service to create a package."),
      otherwise: (schema) => schema.notRequired(),
    }),
});

export const validationSchema = Yup.object().shape({
  packages: Yup.object().shape({
    Basic: packageSchema,
    Standard: packageSchema,
    Premium: packageSchema,
  }),
});

export const formatPayload = (values: typeof initialValues) => {
  return {
    packages: Object.keys(values.packages).map((key) => {
      const pkg = values.packages[key as keyof typeof values.packages];
      return {
        name: key,
        isEnabled: pkg.isActive,
        price: pkg.price !== null ? pkg.price : null,
        description: pkg?.description || null,
        categoryIds: pkg.services?.length ? pkg.services : [],
      };
    }),
  };
};

export const mapBackendDataToForm = (data: any[] = []) => {
  const PACKAGE_KEYS = ["Basic", "Standard", "Premium"];
  const packages: any = {};
  PACKAGE_KEYS.forEach((key) => {
    const pkg = data.find((p) => p.name === key);
    packages[key] = {
      isActive: pkg?.isEnabled ?? false,
      price:
        pkg?.price !== undefined && pkg?.price !== null
          ? Number(pkg.price)
          : null,
      description: pkg?.description ?? null,
      services: pkg?.categories?.map((c: any) => c.id) ?? [],
    };
  });
  return { packages };
};
export const buildUpdatePayload = (originalPkg: any, currentPkg: any) => {
  const payload: any = {};

  if (originalPkg.isActive !== currentPkg.isActive) {
    payload.isEnabled = currentPkg.isActive;
  }

  if (originalPkg.price !== currentPkg.price) {
    payload.price = currentPkg.price;
  }

  if ((originalPkg.description ?? "") !== (currentPkg.description ?? "")) {
    payload.description = currentPkg.description;
  }

  const originalServices = originalPkg.services ?? [];
  const currentServices = currentPkg.services ?? [];

  if (
    originalServices.length !== currentServices.length ||
    !originalServices.every((id: number) => currentServices.includes(id))
  ) {
    payload.categoryIds = currentServices;
  }

  return payload;
};
export const mapSinglePackageToForm = (pkg: any) => ({
  isActive: pkg?.isEnabled ?? false,
  price: pkg?.price !== null ? Number(pkg.price) : null,
  description: pkg?.description ?? null,
  services: pkg?.categoryIds ?? [],
});
